import {
  SiReact,
  SiTypescript,
  SiNodedotjs,
  SiPython,
  SiDocker,
  SiGit,
  SiPostgresql,
  SiMongodb,
  SiAmazon,
  SiVuedotjs,
  SiGraphql,
  SiRedis,
} from "react-icons/si";
import { RiRobot2Fill, RiCursorFill } from "react-icons/ri";
import { BsStars } from "react-icons/bs";
import { TechIconName } from "./types";

export const ICON_COLORS: Record<TechIconName, string> = {
  react: "#61DAFB",
  typescript: "#3178C6",
  node: "#339933",
  python: "#FFD43B",
  docker: "#2496ED",
  git: "#F05032",
  postgres: "#4169E1",
  mongodb: "#47A248",
  aws: "#FF9900",
  vue: "#4FC08D",
  graphql: "#E10098",
  redis: "#DC382D",
  cursor: "#A78BFA",
  claude: "#D97706",
  gpt: "#10A37F",
};

export const ICON_COMPONENTS: Record<TechIconName, React.ComponentType> = {
  react: SiReact,
  typescript: SiTypescript,
  node: SiNodedotjs,
  python: SiPython,
  docker: SiDocker,
  git: SiGit,
  postgres: SiPostgresql,
  mongodb: SiMongodb,
  aws: SiAmazon,
  vue: SiVuedotjs,
  graphql: SiGraphql,
  redis: SiRedis,
  cursor: RiCursorFill,
  claude: RiRobot2Fill,
  gpt: BsStars,
};

// Icon groups for different sections
export const BACKEND_ICONS: TechIconName[] = [
  "node",
  "python",
  "postgres",
  "mongodb",
  "redis",
];
export const FRONTEND_ICONS: TechIconName[] = ["react", "typescript", "vue"];
export const DEVOPS_ICONS: TechIconName[] = ["docker", "git", "aws", "graphql"];
export const AI_ICONS: TechIconName[] = ["cursor", "claude", "gpt"];
